import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { EmployerService } from 'src/app/core/services/v2/employer.service';
import { UserService } from 'src/app/core/services/v2/user.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { EmployerTeldacplanComponent } from '../employer-teldacplan/employer-teldacplan.component';
import { EmployerTeldacFaqplanComponent } from '../employer-teldac-faqplan/employer-teldac-faqplan.component';
import { UtilsService } from 'src/app/core/services/v2/utils.service';

@Component({
  selector: 'app-employer-plan-details',
  templateUrl: './employer-plan-details.component.html',
  styleUrls: ['./employer-plan-details.component.scss']
})
export class EmployerPlanDetailsComponent implements OnInit {

  plan: any;
  sortedPlans: any[] = [];
  planDetails: any[] = [];
  subscriptionPlans: any [] = [];
  selectedPlan: string = '';

  user: any = [];
  subscriptionType: number;
  selectedType: number = 0;
  activationType: string;
  userId: number;
  employerId: number;
  isActive: boolean;
  subscribedPlan: string;
  selectedPlans: any;
    constructor(
          private userService: UserService,
          private employerService: EmployerService,
          private loaderService: WindowLoaderService,
          private resolver: ComponentFactoryResolver,
          private utils: UtilsService,
          
          
    ) { }
    // @ViewChild('dynamicContainer',{static: true})   container!: ViewContainerRef;
    // @ViewChild('dynamicContainer', { read: ViewContainerRef, static: true })   container!: ViewContainerRef;
 
 
    // loadDynamicComponent(component) { 
    //   // this.container.clear();
    //   const factory = this.resolver.resolveComponentFactory(component);
    //        this.container.createComponent(factory); 
           
    //       }
  ngOnInit() {
    this.getUserDetails();

    console.log("recived plan details",history.state.data)
        // Accessing the data passed through state
        this.plan = history.state.data;
 
  

  }

onTabClick(planName: string): void {
  this.selectedPlan = planName;
  console.log("selected plan",this.selectedPlan);
  
}
  getUserDetails() {
    this.loaderService.show();
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.user = userDetails;
        console.log("user", this.user);
        this.userId = userDetails.id;
        this.employerId = userDetails.employerId
        console.log("This is userId: ", this.userId);
        console.log("This is employerId: ", this.employerId);
        this.getEmployerHealthSubscriptionByEmployerId();

      },
      (error) => { console.error(error); }
    );
  }
  
 
  getEmployerHealthSubscriptionByEmployerId1() {
    this.loaderService.show(); // Show a loader while fetching data
    
    this.employerService.getEmployerHealthSubscription(this.user.employerId).subscribe(
      (res) => {
        // Check if the response contains valid data and if the resultStatus is success
        if (res && res.resultStatus && res.resultStatus.isSuccess) {
          const result = res.result;
  
          console.log("Subscription Details:", result);
          this.subscribedPlan = result.subscriptionType.name;
  
          // Set the active status and subscriptionTypeId from the API response
          const active = result.active;
          this.selectedType = result.subscriptionTypeId;
          this.activationType = active ? "Activate" : "Deactivate";
  
          // Assign subscription plans from the API response
          this.planDetails = result.subscriptionPlans;
  
          console.log("Plan Details:", this.planDetails);
  
          // Sort the plans by PlanDisplayOrder in ascending order
          this.sortedPlans = this.planDetails.sort(
            (a, b) => a.planDisplayOrder - b.planDisplayOrder // Correct casing to match your API keys
          );
  
          // Set the first plan as the default selected plan, if available
          if (this.sortedPlans.length > 0) {
            this.selectedPlan = this.sortedPlans[0].planName; // Ensure casing matches API keys
          }
  
          // Update the subscription plan's active status based on subscriptionTypeId
          const selectedPlan = this.planDetails.find(plan => plan.planId === this.selectedType);
          if (selectedPlan) {
            selectedPlan.active = active; // Ensure the plan's active status is updated
          }
  
          this.loaderService.hide(); // Hide the loader after processing
        } else {
          // If isSuccess is false, show the error message
          const errorMessage = res.resultStatus.errorMessages
            ? res.resultStatus.errorMessages.join(", ")
            : "Failed to fetch subscription details.";
          
          this.utils.showMessageSnackBar(errorMessage, true);
          this.loaderService.hide(); // Hide the loader
        }
      },
      (error) => {
        // Handle HTTP errors and hide the loader
        console.error("Error fetching subscription details:", error);
        this.utils.showMessageSnackBar("An error occurred while fetching subscription details.", true);
        this.loaderService.hide();
      }
    );
  }
  
  getEmployerHealthSubscriptionByEmployerId111() {
    this.loaderService.show(); // Show a loader while fetching data
  
    this.employerService.getEmployerHealthSubscription(this.user.employerId).subscribe(
      (res) => {
        if (
          res &&
          res.resultStatus &&
          res.resultStatus.isSuccess &&
          Array.isArray(res.result)
        ) {
          const result = res.result;
  
          console.log("Subscription Details:", result);
  
          // Ensure selectedPlans is always an array
          this.selectedPlans = result;
  
          if (this.selectedPlans.length > 0) {
            const firstPlan = this.plan;
            this.subscribedPlan = firstPlan.subscriptionType.name;
  
            this.planDetails = firstPlan.subscriptionPlans || [];
  
            // Sort by PlanDisplayOrder
            this.sortedPlans = this.planDetails.sort(function (a, b) {
              return a.planDisplayOrder - b.planDisplayOrder;
            });
  
            // Set default selected plan
            if (this.sortedPlans.length > 0) {
              this.selectedPlan = this.sortedPlans[0].planName;
            }
          }
  
          this.loaderService.hide();
        } else {
          var errorMessage = "Failed to fetch subscription details.";
          if (
            res &&
            res.resultStatus &&
            res.resultStatus.errorMessages &&
            res.resultStatus.errorMessages.length > 0
          ) {
            errorMessage = res.resultStatus.errorMessages.join(", ");
          }
  
          this.utils.showMessageSnackBar(errorMessage, true);
          this.loaderService.hide();
        }
      },
      (error) => {
        console.error("Error fetching subscription details:", error);
        this.utils.showMessageSnackBar("An error occurred while fetching subscription details.", true);
        this.loaderService.hide();
      }
    );
  }
  getEmployerHealthSubscriptionByEmployerId(): void {
    this.loaderService.show();

    this.employerService.getEmployerHealthSubscription(this.user.employerId).subscribe(
      (res) => {
        if (res && res.resultStatus.isSuccess && Array.isArray(res.result)) {
          this.selectedPlans = res.result;

          let matchedPlan;
          if (this.plan.subscriptionTypeId) {
            matchedPlan = this.selectedPlans.find(
              plan => plan.subscriptionTypeId === this.plan.subscriptionTypeId
            );
          }

          const planToUse = matchedPlan || this.selectedPlans[0];

          this.subscribedPlan = planToUse.subscriptionType.name || '';
          this.planDetails = planToUse.subscriptionPlans || [];

          this.sortedPlans = this.planDetails.sort((a, b) => a.planDisplayOrder - b.planDisplayOrder);

          if (this.sortedPlans.length > 0) {
            this.selectedPlan = this.sortedPlans[0].planName;
          }

          this.loaderService.hide();
        } else {
          const errorMessage = res.resultStatus.errorMessages.join(', ') || 'Failed to fetch subscription details.';
          this.utils.showMessageSnackBar(errorMessage, true);
          this.loaderService.hide();
        }
      },
      (error) => {
        console.error("Error fetching subscription details:", error);
        this.utils.showMessageSnackBar("An error occurred while fetching subscription details.", true);
        this.loaderService.hide();
      }
    );
  }

}
